import React, { useEffect, useState } from "react";
import Button from 'antd/lib/button';
import Checkbox from 'antd/lib/checkbox';
import DatePicker from 'antd/lib/date-picker';
import Drawer from 'antd/lib/drawer';
import Icon from 'antd/lib/icon';
import Select from 'antd/lib/select';
import { MOBILE_BREAK_POINT } from "src/globals";
import Loader from "src/components/common/Loader";
import moment from "moment";
import GenericHoc from "src/components/hoc/GenericHoc";
import { HocOptions } from 'src/components/hoc/GenericHoc.types';
import useDocumentType from "src/hooks/fields/useDocumentType";
import useUploadedByOrg from "src/hooks/fields/useUploadedByOrg";
import Radio from "antd/lib/radio";

const styles = () => ({
  [`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
    mainDiv: {
      display: 'inline-block',
    },
  },
  mainDiv: {
    height: '100%',
  },
  drawer: {
    // '& .ant-drawer-content': {
    //   height: '80%',
    // },
  },
  childDiv: {
    display: 'flex',
  },
  leftElement: {
    fontSize: 12,
    fontWeight: 600,
    margin: '5px 16px 0px 0px'
  },
  rightElement: {
    width: '370px',
    fontSize: 12,
    '& .ant-input': {
      fontSize: 12,
    },
  },
  hrElement: {
    border: 'none',
    borderTop: '1px double #EDEDED',
    color: '#EDEDED',
    marginBottom: 15,
  },
  contentDiv: {
    padding: '5px 0px',
    display: 'flex',
    justifyContent: 'space-between',
    '& .ant-drawer-header':{
      padding: '10px 24px',
    },
  },
});

interface SEDocumentsFilterDrawerProps {
  classes: {
    [X in keyof ReturnType<typeof styles>]: string
  };
  form: any;
  visible: boolean;
  handleClose: () => void;
  type: string;
  handleResetMoreFilters: () => void;
  id: any;
  pagination: any;
}

const SEDocumentsFilterDrawer = (props: SEDocumentsFilterDrawerProps) => {
  const { classes, visible, handleClose, type, form, handleResetMoreFilters, id, pagination } = props;

  const [ isLoading, setIsLoading ] = useState(false);

  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;

  const documentType = useDocumentType({
    form,
    disabled: false,
    visible: true,
    key: "documentType",
    label: "Document Type",
    placeholder: "Document Type",
  }, { id });

  const uploadedByOrg = useUploadedByOrg({
    form,
    disabled: false,
    visible: true,
    key: "uploadedByOrg",
    label: "Uploaded By - Org",
    placeholder: "Upload by Organisation",
  }, { id } );

  useEffect(() => {
    documentType.setValue(pagination.state.appliedFilters.documentTypeList);
    uploadedByOrg.setValue(pagination.state.appliedFilters.organisationIdList);
    setFieldsValue({ source: pagination.state.appliedFilters.sourceObjectTypeList });
    setFieldsValue({ dateRange: pagination.state.appliedFilters.dateRange });
  }, [pagination.state.appliedFilters])

  const handleApply = () => {
    
    const updatedAt = getFieldValue('dateRange');
    const date: any = { startDate: moment(), endDate: moment() };
    date.startDate = moment(updatedAt?.[0]).utc().startOf('day').valueOf();
    date.endDate = moment(updatedAt?.[1]).utc().endOf('day').valueOf();

    pagination.actions.setFilter({
      documentTypeList: documentType.value,
      organisationIdList: uploadedByOrg.value,
      sourceObjectTypeList: getFieldValue('source'),
      updatedAt: updatedAt?.length ? date :  undefined,
      dateRange: getFieldValue('dateRange'),
    }, true);

    handleClose();
  }

  const handleReset = () => {
    pagination.actions.setFilter({
      documentTypeList: [],
      organisationIdList: undefined,
      sourceObjectTypeList: [],
      updatedAt: {},
      dateRange: undefined,
    }, true);

    // handleClose();
  }

  const drawerTitle = () => (
    // const { classes, handleClose, teamName } = this.props;
    <div className={classes.contentDiv}>
      <div>
        <Icon type="close" onClick={handleClose} />
        <span style={{ marginLeft: 10, fontSize: 20, fontWeight: 600 }}>Filters</span>
      </div>
      <div style={{ color: '#DF1D1D', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
        onClick={handleReset}>
        Reset Filter
      </div>
    </div>
  )

  const renderDocumentTypeFilter = () => {
    return <div className={classes.childDiv} >
      <span className={classes.leftElement}>Document Type</span>
      {documentType.decorator(<Select mode="multiple"
        className={classes.rightElement}
      >
      </Select>)}
    </div>;
  }

  const renderUploadedByOrgFilter = () => {
    return <div className={classes.childDiv} >
      <span className={classes.leftElement}>Upload by Organisation</span>
      {uploadedByOrg.decorator(<Select mode="default"
        className={classes.rightElement}
        allowClear
      >
      </Select>)}
    </div>;
  }

  const renderDateRangeFilter = () => {
    return (
      <div className={classes.childDiv} >
        <span className={classes.leftElement}>Upload Date</span>
        {
          getFieldDecorator('dateRange', {
          })
            (<DatePicker.RangePicker
              className={classes.rightElement}
              style={{ marginLeft: 13 }}
            />)
        }
      </div>
    )
  }

  const renderSourceFilter = () => {
    const sourceOptions = [
      { label: 'Task', value: 'TASK' },
      { label: 'Shipment/Booking', value: 'SHIPMENT' },
    ];
    return <div className={classes.childDiv}>
      <span className={classes.leftElement}>Source</span>
      {
        getFieldDecorator('source', {
        })
          (<Radio.Group
            options={sourceOptions}
            className={classes.rightElement}
            style={{ marginLeft: 45 }}
          />)
      }
    </div>;
  }

  const renderFooter = () => {
    return (
      <div
        style={{
          position: 'absolute',
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e8e8e8',
          padding: '10px 16px',
          textAlign: 'left',
          left: 0,
          background: '#fff',
          borderRadius: '0 0 4px 4px',
        }}
      >
        <Button onClick={handleApply} type="primary" style={{ marginLeft: 10, marginRight: 20 }}>
          Apply
        </Button>
        <a style={{ color: '#000' }} onClick={handleClose}>
          Cancel
        </a>
      </div>
    );
  };

  const renderLine = () => {
    return <hr className={classes.hrElement} style={{ marginTop: 15 }} />;
  };

  return <Drawer
    className={classes.drawer}
    visible={visible}
    closable={false}
    width='519.7px'
    height='650px'
    title={drawerTitle()}
    onClose={handleClose}>
    
    <div className={classes.mainDiv} >
      <div>
        {isLoading ? <Loader /> : null}
      </div>
      {renderDocumentTypeFilter()}
      {renderUploadedByOrgFilter()}
      {renderDateRangeFilter()}
      
      {renderLine()}
      {renderSourceFilter()}
      {renderFooter()}
    </div>
    
  </Drawer>
}

const options: HocOptions = {
  connectForm: {
    useForm: true,
  },
  connectJss: {
    useJss: true,
    styleSheet: styles,
  },
};

const SEDocumentsFilterDrawerWithHOC = GenericHoc(options)(SEDocumentsFilterDrawer);
export default SEDocumentsFilterDrawerWithHOC;
